import { RECEIVE_PERMISSIONS } from "../actions/permissions";

export default function permissions(state = [], action) {
  switch (action.type) {
    case RECEIVE_PERMISSIONS:
      return action.permissions;
    default:
      return state;
  }
}
